import { List } from 'cypress/types/lodash'

export enum TipoEnvioCiclo {
  CiclosAntigos = 0,
  Planilha = 1,
  API = 2
}

export type TipoGatilhoCiclo = string

export enum TipoStatusExecucaoCiclo {
  Novo = 0,
  ErroAquivo = 1,
  ErroValidacao = 2,
  Validado = 3,
  Divergente = 4,
  Rejeitado = 5,
  Aprovado = 6,
  Sucesso = 7
}

export interface ExecucaoCiclo {
  id: number
  parceiroId: number
  cicloId: number
  dataSolicitacaoRepasse: Date
  dataInicialOriginal: Date
  dataFinalOriginal: Date
  dataInicialAjustada?: Date
  dataFinalAjustada?: Date
  tipoEnvio: TipoEnvioCiclo
  tipoGatilho: TipoGatilhoCiclo
  pularValidacoes: boolean
  intervencaoManual: boolean
  status: TipoStatusExecucaoCiclo
}

export interface ExecucaoCicloTabela {
  pageNumber: number
  pageSize: number
  totalItens: number
  totalPages: number
  itens: ExecucaoCiclo[]
}

export interface ExecucaoCicloFiltros {
  parceiroId?: number
  status?: TipoStatusExecucaoCiclo
  dataInicio?: Date
  dataFim?: Date
}

export interface ObterExecucoesCicloApiQuery {
  parceiroId: number
  pageNumber: number
  pageSize: number
}

export type AprovarValidacaoCicloApibody = {
  parceiroId: number
  funcionarioId: number
  cicloId: number
  envio: number
  aprovar: boolean
  skip: boolean
}

export type AprovarValidacaoResponse = {
  dataObject?: boolean
  success: boolean
  messages: List<string>
}

export interface HistoricoExecucaoCicloResponse {
  id: number
  parceiroId: number
  cicloId: number
  horarioAlteracao: string | Date
  status: number
  funcionarioId: number
  funcionario: string
}
